import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { getSiteDomain } from '../utils/common';
import makeRequest from './makeRequest';

export default function fetchExperimentRelatedVideos() {
  let type;
  let gaAction = '';
  if (this.props.categoryType === 'video') {
    type = 'abrelatedvideos';
    gaAction = 'Fallback_RelatedVideo';
  } else if (this.props.categoryType === 'article') {
    type = 'abrelatedarticles';
    gaAction = 'Fallback_RelatedArticles';
  }
  // const gaCategory = this.props.isWapView ? 'mWeb-videoshow' : 'Web-videoshow';
  if (this.props && this.props.msid) {
    const dataUrl = `${getSiteDomain()}/feed/feed_videoshow_bottom_widget/msid-${
      this.props.msid
    },feedtype-sjson.cms?type=${type}`;
    makeRequest
      .get(dataUrl, {}, 'skipfeedengine')
      .then(result => {
        if (
          result &&
          result.data &&
          result.data.data &&
          result.data.data.items
        ) {
          if (result.data.data.items.length >= 10)
            this.setState({ category: result.data });
          else {
            sendGaThroughProps({
              data: {
                gaCategory: `${
                  typeof window !== 'undefined' && window.categoryForGA
                    ? window.categoryForGA
                    : `Videoshow`
                }`,
                gaAction,
                gaLabel: `${this.props.msid}_${
                  result.data.data.items.length
                } records found.`,
              },
            });
          }
        }
      })
      .catch(e => {
        sendGaThroughProps({
          data: {
            gaCategory: `${
              typeof window !== 'undefined' && window.categoryForGA
                ? window.categoryForGA
                : `Videoshow`
            }`,
            gaAction,
            gaLabel: `${this.props.msid}_Error-${e}`,
          },
        });
      });
  } else {
    sendGaThroughProps({
      data: {
        gaCategory: `${
          typeof window !== 'undefined' && window.categoryForGA
            ? window.categoryForGA
            : `Videoshow`
        }`,
        gaAction,
        gaLabel: `MSID of this video not available here.`,
      },
    });
  }
}
